import { formatLfPageTitle } from "./pageTitle";
import { PAGE_SHELL_BG, type PageShellBgState } from "./pageShellBg";

/** 空间 Tab：标题固定「龙粉社-${空间名}」；仅背景随 Tab 变化 */
export function resolveSpaceTabShellBg(input: {
  activeTab: string;
  spaceName?: string | null;
}): PageShellBgState {
  const { activeTab, spaceName } = input;
  const title = formatLfPageTitle(spaceName);

  if (activeTab === "home") {
    return {
      bg: PAGE_SHELL_BG.spaceHome,
      front: "#ffffff",
      title,
    };
  }

  return {
    bg: PAGE_SHELL_BG.spaceLight,
    front: "#000000",
    title,
  };
}
